// react library imports
import { useNavigate } from "react-router-dom/dist";
import { useSelector, useDispatch } from "react-redux";
import { PlusCircle, Power } from "phosphor-react";

// style imports
import "./Topbar.css";

// redux store imports
import {
  getUserInformation,
  addDirectorInformation,
} from "Redux/userOnboard/userOnboard";
import { openLogOut } from "Redux/sidebar/sidebar";

const Topbar = () => {
  // fetch information and define dispatch action from redux store
  const dispatch = useDispatch();
  const user = useSelector(getUserInformation);

  // define navigation
  const navigate = useNavigate();

  // handle add new preschool
  const handleAddNewPreschool = () => {
    const directorInformation = {
      first_name: user?.user?.first_name,
      last_name: user?.user?.last_name,
      email_address: user?.user?.email_address,
      mobile_number: user?.user?.mobile_number,
    };
    dispatch(addDirectorInformation(directorInformation));
    return navigate("/register/step-1", { relative: "path" });
  };
  return (
    <section className="top_bar mues_row_space_between">
      <img
        src="https://mues-solution.s3.ap-south-1.amazonaws.com/svg/mues-tech.svg"
        alt="mues_logo"
      />
      <div className="top_bar_button_container">
      <div className="mues_row_flex mues_column_gap_8 top_bar_button">
        <button className="blue_btn btn add_preschool_button"  onClick={handleAddNewPreschool}>
          Add New Preschool
        </button>
        <button className="btn add_preschool_button red_btn" onClick={() => dispatch(openLogOut())}>
          Logout
        </button>
      </div>
      <div className="mues_row_flex mues_column_gap_8 top_bar_icon">
        <PlusCircle className="top_bar_icon_item mues_blue" weight="fill" onClick={handleAddNewPreschool} />
        <Power className="top_bar_icon_item mues_red" weight="fill" onClick={() => dispatch(openLogOut())} />
      </div>
      </div>
    </section>
  );
};

export default Topbar;
